module.exports = __webpack_public_path__ + "static/tetleys-coaches-living-wage-employer-accreditation-sm-0e89e8c8f9120f573e0a9747a7b0f39a.png";